/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>案例管理</el-breadcrumb-item>
      <el-breadcrumb-item>案例回访审核</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
		<div class="block">
			 <el-radio-group v-model="tabPosition" style="margin-top: 50px;" @change="choosebt">
				 <el-radio-button label="安装案例" >安装案例</el-radio-button>
				 <el-radio-button label="回访案例">回访案例</el-radio-button>
			 </el-radio-group>     
		</div>
        <el-form :inline="true" :model="formCase" class="user-search">
         
          <el-form-item label="案例名称">
            <el-input size="small" v-model="formCase.name" placeholder="输入案例名称"></el-input>
          </el-form-item>
          <!-- <el-form-item label="案例类型">
           <el-select size="small" v-model="formCase.caseCategory" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="精品案例" value="BOUTIQUE"></el-option>
              <el-option label="用户回访" value="CALLBACK"></el-option>
            </el-select>
          </el-form-item> -->
         <el-form-item label="创建方式">
           <el-input size="small" v-model="formCase.createType" placeholder="输入创建方式"></el-input>
         </el-form-item>
		 
		 <el-form-item label="创建人">
		   <el-input size="small" v-model="formCase.createName" placeholder="输入创建人"></el-input>
		 </el-form-item>
    	  
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-form-item>
        </el-form>
		<el-button size="small" type="primary" @click="handleEdit()" class="add">批量审核</el-button>
        <!--列表-->
        <el-table size="small" @selection-change="selectChange" :data="caseList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="50">
          </el-table-column>
          <el-table-column align="center" prop="name" label="案例名称" >
          </el-table-column>
          <el-table-column align="center" prop="firstLevelName" label="创建人">
          </el-table-column>
          <el-table-column align="center" prop="createType" label="创建方式">
          </el-table-column>
          <el-table-column align="center" prop="createTime" label="创建时间" >
          </el-table-column>
          <el-table-column  align="center"  label="操作" >
            <template slot-scope="scope">

              <!-- <el-button size="mini" type="success" @click="getDatas(scope.$index, scope.row.id)">查看</el-button> -->
              <el-button size="mini"  type="primary" @click="handleEdit(scope.row)">审核</el-button>
			 
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @close='closeDialog()'>
		  <div class="tipstitle">确认要审核所案例回访审核么？</div>
		  <div class="tips">操作后无法撤回，请思考一下哟！</div>
          <el-form label-width="120px" ref="editForm" :model="editForm" >
			
            <el-form-item label="案例名称" prop="caseName" v-if="dataAccessshow">
			  
              <el-input size="small" v-model="editForm.caseName" auto-complete="off" placeholder="请输入案例名称"></el-input>
            </el-form-item>
           
            <div>
            

            <el-form-item   label="内容" v-if="dataAccessshow">
              
              <el-upload
                class="upload-demo"
                :action="uploadUrl()"
                :file-list="resultFilelist2"
                list-type="picture-card">
               
                <div slot="file" slot-scope="{file}">
                  <video
                    class="el-upload-list__item-thumbnail"
                    :src="file.url" alt=""
                    :autoplay="true"
                  ></video>
                 
                </div>
              </el-upload>
              
            </el-form-item>
            
            <el-form-item   label="理由"  >
              <el-input style="margin-top:10px"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 6}"
                placeholder="理由"
                v-model="editForm.reviewReason">
              </el-input>
            </el-form-item>
          </div>


            
          </el-form>

          


          <div slot="footer" class="dialog-footer" v-if="dataAccessshow">
            <el-button size="small" @click='examineApprove("已拒绝")' type="danger">拒绝</el-button>
            <el-button size="small"  @click='examineApprove("已通过")' type="primary" :loading="loading">通过</el-button>
          </div>
		  <div slot="footer" class="dialog-footer" v-else>
		    <el-button size="small" @click='batchApproval("已拒绝")' type="danger">拒绝</el-button>
		    <el-button size="small"  @click='batchApproval("已通过")' type="primary" :loading="loading">通过</el-button>
		  </div>
          
        </el-dialog>
		
		
      </div>
    </template>

    <script>
    // 导入请求方法
    import { uploadFile } from '../../api/axiosFun';
    import {
	  searchcase,
	  reviewbatch,
	  getcustomerCase,
	  reviewone
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
		  tabPosition:'安装案例',
          dateValue:[],
          loading: false, //是显示加载
          title: '',
          editFormVisible: false, //控制编辑页面显示与隐藏
          dataAccessshow: false, //控制数据权限显示与隐藏
		  // 选择数据
		  selectdata: [],
		  
		  
		  // 请求数据参数
		  formCase: {
		    pageIndex: 1,
		     pageSize: 10,
		     // 产品名称(支持右模糊查询)
		     name: '',
		     createType: '',
		     createName:'',
		    reviewStatue:'待审核',
		    caseType:'安装案例'
		  },
		  
		  //客户案例列表
		  caseList: [],
		           
		  
		  // 分页参数
		  pageparm: {
		    currentPage: 1,
		    pageSize: 10,
		    total:0,
		  },
		  
          // 编辑与添加
          editForm: {
            reviewId: '',
            reviewName: '',
            reviewMobile:'',
            reviewReason:'',
            passOrNot: ''
          },
          resultFilelist2:[],
          
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        this.getData(this.formCase)

      },
      mounted(){
        // document.addEventListener("paste", this.handlePaste);
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		// 获取数据方法
		getData(pageparm) {
		  this.loading = true
		  console.log(pageparm)
		 
		  searchcase(pageparm).then(res => {
		    console.log(123)
		    this.loading = false
		    if (res.success == false) {
		      this.$message({
		        type: 'info',
		        message: res.msg
		      })
		    } else {
		      this.caseList = res.data
		
		      // 分页赋值
		        this.pageparm.currentPage = this.formCase.pageIndex
		        this.pageparm.pageSize = this.formCase.pageSize
		        this.pageparm.total = res.total
		    }
		  })
		},
		// 分页插件事件
		callFather(parm) {
		  this.formCase.pageIndex = parm.currentPage
		  this.formCase.pageSize = parm.pageSize
		  this.getData(this.formCase)
		},
		//搜索事件
		search() {
		  this.formCase.pageIndex = 1
		  this.getData(this.formCase)
		},
		
		choosebt(e){
			console.log(9090909,e)
			this.formCase.caseType = e
			this.getData(this.formCase)
		},
		
		// 选择复选框事件
		selectChange(val) {
			
			val.map((item,index)=>{
				this.selectdata.push(item.id)
			})
		   console.log(8989898989,this.selectdata)
		  
		},
		
		// 批量审批
		batchApproval: function(e) {
		  this.loading = true
		  this.editForm.passOrNot = e
		  this.editForm.caseIdList = this.selectdata
		  reviewbatch(this.editForm).then(res => {
		    this.loading = false
		    if (res.success == false) {
		      this.$message({
		        type: 'info',
		        message: res.msg
		      })
		    } else {
		      this.$message({
		        type: 'success',
		        message: '提交成功'
		      })
			  this.editFormVisible = false
			  this.resultFilelist2 = []
		      this.getData(this.formCase)
		    }
		  })
		},
		
		// 审批
		examineApprove: function(e) {
		  this.loading = true
		  this.editForm.passOrNot = e
		  reviewone(this.editForm).then(res => {
		    this.loading = false
		    if (res.success == false) {
		      this.$message({
		        type: 'info',
		        message: res.msg
		      })
		    } else {
		      this.$message({
		        type: 'success',
		        message: '提交成功'
		      })
			  this.editFormVisible = false
			  this.resultFilelist2 = []
		      this.getData(this.formCase)
		    }
		  })
		},
		
		
		//显示编辑界面
		handleEdit: function(row) {
		  let _this = this
		  this.resultFilelist2 = []
		  if (row != undefined && row != 'undefined' &&row != '') {
			this.dataAccessshow = true
			this.editFormVisible = true
		    this.title = '审核'
		    getcustomerCase(row.id)
		      .then(res => {
		        console.log(res)
		        this.loading = false
		        if (res.success == false) {
		          this.$message({
		            type: 'info',
		            message: res.msg+'TraceId:'+res.traceId
		          })
		        } else {
		          console.log(res)
		          let data = res.data
		          this.editForm.caseName = data.caseName
		          this.editForm.caseId =  data.id
		          this.editForm.caseCategory = data.caseCategory
				  this.resultFilelist2.push({
				          url:data.queryVideoDtoList[0].fileTemporaryUrl,
				          fileTemporaryUrl:data.queryVideoDtoList[0].fileTemporaryUrl,
				          fileId:data.queryVideoDtoList[0].fileId,
						  uid: data.queryVideoDtoList[0].fileId,
				      })
		         
		         }   
		          
		      })
		
		  }else{
			if(this.selectdata.length<=0){
				this.$message({
				  type: 'warning',
				  message: '请勾选审核案例'
				})
			}else{
				this.dataAccessshow = false
				this.editFormVisible = true
			}
			
		  }
		  
		  
		  
		},
		
        uploadUrl(){
          return '/mtl/marking/api/main/oss-file/upload-file'
        },
       
       
        // 关闭编辑、增加弹出框
        closeDialog() {
			console.log(9090909)
            this.editFormVisible = false
			this.resultFilelist2 = []
        },
        

      }
    }
    </script>

    <style scoped>
    .user-search {
      margin-top: 20px;
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .block{
  	  display: flex;
  }
  /deep/ .block .el-input__inner{
  	  line-height: 32px;
  	  height: 32px;
  	  border: 0;
  }
  /deep/ .el-input__icon{
  	  font-size: 20px;
  	  height: 36px;
  	  line-height: 32px;
  }
  /deep/ .el-radio-button:first-child .el-radio-button__inner{
  	 border: 0; 
  }
  /deep/ .el-radio-button__inner{
  	  border: 0; 
  }
  /deep/ .el-radio-button__inner{
  	  width: 120px;
  }
  /deep/ .el-radio-button__inner{
  	  padding: 10px 20px;
  }
  .add{
	  margin-bottom: 20px;
  }
  .tipstitle{
	  width: 80%;
	  font-size: 16px;
	  margin: 0 auto;
	  margin-bottom: 10px;
  }
  .tips{
	 width: 80%;
	 font-size: 12px;
	 margin: 0 auto;
	 margin-bottom: 30px;
  }
  /deep/ .el-dialog__body{
	  padding:10px 20px 30px 30px;
  }
  .el-upload--picture-card{
	 border: 0 !important; 
	 background: none;
  }
    </style>





// WEBPACK FOOTER //
// src/views/management/callbackexamine.vue